import { Record, Static, String } from "runtypes";

export const LoginCallbackRequestRuntype = Record({
  code: String,
});

export interface ILoginCallbackRequest
  extends Static<typeof LoginCallbackRequestRuntype> {}



// WEBPACK FOOTER //
// ./src/services/ILoginCallbackRequest.ts